import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Gate untuk route yang hanya bisa diakses kalau sudah login.
 * - Saat app masih bootstrap (cek token + fetch /me) → render loading.
 * - Kalau belum authenticated → redirect ke /login.
 * - Kalau authenticated → render children.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isInitialized, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-gray-500">Memuat...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

/** Kebalikan dari ProtectedRoute — kalau sudah login, redirect ke dashboard. */
export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const { isInitialized, isAuthenticated } = useAuth();

  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-gray-500">Memuat...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
